import { Button } from '@/components/atoms';
import { routes } from '@/lib/constants';
import { markProductTourPending } from '@/lib/onboarding/product-tour-state';
import { useNavigate } from 'react-router';

export const OnboardingSuccessful = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center gap-10 px-4 md:px-6 lg:px-8 text-center h-full">
      <img src="/svg/party-popper.svg" className="w-24 h-24" alt="" />
      <h1 className="font-semibold text-2xl md:text-3xl xl:text-4xl">
        Congratulations
      </h1>
      <p className="text-base md:text-lg lg:text-xl max-w-lg">
        You've successfully created your Sellyt account. Let's walk through
        everything you need to know about your dashboard.
      </p>
      <Button
        label="Visit dashboard"
        size="lg"
        className="w-full"
        onClick={() => {
          markProductTourPending();
          navigate(routes.root);
        }}
      />
    </div>
  );
};

export const ResetPasswordSuccessful = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center gap-10 px-4 md:px-6 lg:px-8 text-center h-full">
      <img src="/svg/party-popper.svg" className="w-24 h-24" alt="" />
      <h1 className="font-semibold text-2xl md:text-3xl xl:text-4xl">
        Password reset successful
      </h1>
      <p className="text-base md:text-lg lg:text-xl max-w-lg">
        Your password has been updated. You can now sign in with your new
        credentials.
      </p>
      <Button
        label="Proceed to login"
        size="lg"
        className="w-full"
        onClick={() => navigate(routes.login)}
      />
    </div>
  );
};
